import cn from 'classnames';
import { memo, useState } from 'react';
import { useMobile } from '@shared/hooks/index.ts';
import { FormFieldWithLabelAndCard } from '@shared/ui/forms/FieldWithLabel/index';
import {
  SCard,
  SImageInputCropperM,
  SName,
  SNameNearImage,
  STextareaWrapper,
} from '@shared/ui/forms/ImageAndName/styles';
import type { TextareaMPT } from '@shared/ui/inputs/TextareaM/ui';
import * as st from './styles.module.scss';

type PT = TextareaMPT & {
  imageClassName?: string;
  textareaClassName?: string;
  onImageChange: (img: string) => void;
  onTitleChange: (title: string) => void;
  imageValue?: string | File;
  titleValue?: string;
  imageError?: string;
  titleError?: string;
};

export const FormImageAndName = memo(
  ({
    imageClassName,
    textareaClassName,
    className,
    onImageChange,
    imageError,
    titleError,
    placeholder,
    required,
    imageValue,
    onTitleChange,
    titleValue = '',
    //Все остальные пропсы пойдут в textarea
    ...props
  }: PT) => {
    const { isMobile } = useMobile();
    const [textareaValue, setTextareaValue] = useState(titleValue);
    const textarea = (id: string) => (
      <STextareaWrapper
        id={id}
        onKeyDown={(e) => (e.key === 'Enter') && e.preventDefault()}
        className={textareaClassName}
        error={titleError}
        placeholder={isMobile ? undefined : placeholder}
        required={required}
        value={textareaValue}
        autosize={isMobile}
        onChange={(e) => {
          const stringValue = e.currentTarget.value;
          onTitleChange(stringValue);
          setTextareaValue(stringValue);
        }}
        {...props}
      />
    );
    return (
      <>
        <SCard className={className}>
          <SImageInputCropperM
            className={imageClassName}
            aspect={[16, 9]}
            iconVariant="cover"
            value={imageValue}
            onChange={onImageChange}
            error={imageError}
          />
          {/*Прячем на планшете*/}
          <SNameNearImage $shouldHideOnMobileL>
            {textarea(isMobile ? '' : 'formTextareaNearCropper')}
          </SNameNearImage>
        </SCard>
        {/*Показываем на мобилке*/}
        <SName>
          <FormFieldWithLabelAndCard
            fieldLabel={placeholder}
            // requiredField={required}
            className={cn(className, isMobile && st.forAutosize)}
          >
            {textarea(isMobile ? 'formTextareaNearCropper' : '')}
          </FormFieldWithLabelAndCard>
        </SName>
      </>
    );
  }
);
